import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/TrackHistoryforProxy.css';
import Message from '../../../Data/Shared/Message.json';
import download from '../../../Assets/TruckVisits/Assets/download.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { PREADVISE_PROXY, DOCUMENT_ENDPOINT } from '../../../Services/config/apiEndPoints';
import DownloadFile from '../../../Services/utils/DownloadFile';
import { Link } from 'react-router-dom';
class TrackHistoryforProxy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            proxyHistoryData: [],
            MScData: [],
            ONEData: [],
            newProxyHistoryData: [],
            documentURL: utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=",
            historyNotAvailable: false
        }
    }
    getProxyData = () => {
        ApiCall(
            'GET',
            utilityBaseURL + PREADVISE_PROXY,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                    this.setState({ historyNotAvailable: true });
                }
                else {
                    console.log('I am 200!');
                    this.setState({ proxyHistoryData: apiData }, () => {
                        let MScData = [];
                        let ONEData = [];
                        this.state.proxyHistoryData?.forEach(sd => {
                            if (sd?.shippingLine == "MSc") {
                                MScData.push(sd);
                            }
                            else {
                                ONEData.push(sd);
                            }
                        });
                        this.setState({ MScData, ONEData }, () => {
                            this.setState({ newProxyHistoryData: [[...ONEData], [...MScData]] })
                        });
                    })
                }
            }
        });
    }
    componentDidMount = () => {
        this.getProxyData();
    }
    downloadDocument = (path) => {
        DownloadFile(path, 'Proxy_Document');
    }
    render() {
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.trackHistoryForProxyPageTitle} description={TitleDescription.trackHistoryForProxyPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullTrackProxy">
                    <div id="caacsnobox1preex">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarname">
                                <small id="nonavc">Track History for Proxy</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        {!this.state.historyNotAvailable ?
                            <div class="arcaanotificationmaincardtrackh">
                                {(this.state.newProxyHistoryData?.map((name, i) => {
                                    return (
                                        name?.length > 0 &&
                                        <div class="trackhistorydiv">
                                            <div class="trackhistorydivinborder">
                                                <div class="trackhistorydivinup">
                                                    <small class="trackhistoryuptextl">Shipping Line</small>
                                                    <small class="trackhistoryuptextr">{name[0]?.shippingLine}</small>
                                                </div>
                                            </div>
                                            <div class="trackhistorydivin">
                                                <div class="trackhistorydivindown">
                                                    {(this.state.newProxyHistoryData[i]?.map((datahistory, index) => {
                                                        return (
                                                            <>
                                                                {(datahistory?.approvalStatus === "Revoked")
                                                                    &&
                                                                    <div class="trackhistorydivcol1" style={{ paddingLeft: (index % 3 === 0) && "0" }}>
                                                                        <small class="trackhistorydivtexthorenge">{datahistory?.approvalStatus}</small>
                                                                        <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                    </div>
                                                                }
                                                                {/* //for mobile view */}
                                                                <div class="onlycolformobile">
                                                                    <div class="trackhistorydivcol1mobile">
                                                                        {(datahistory?.approvalStatus === "Revoked")
                                                                            &&
                                                                            <>
                                                                                <small class="trackhistorydivtexthorenge">{datahistory?.approvalStatus}</small>
                                                                                <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                            </>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {(datahistory?.approvalStatus === "Approved")
                                                                    &&
                                                                    <div class="trackhistorydivcol2" style={{ paddingLeft: (index % 3 === 0) && "0" }}>
                                                                        <small class="trackhistorydivtexthgreen">{datahistory?.approvalStatus}</small>
                                                                        <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                    </div>
                                                                }
                                                                {(datahistory?.approvalStatus === "Rejected")
                                                                    &&
                                                                    <div class="trackhistorydivcol2" style={{ paddingLeft: (index % 3 === 0) && "0" }}>
                                                                        <small class="trackhistorydivtexthred">{datahistory?.approvalStatus}</small>
                                                                        <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                    </div>
                                                                }
                                                                {(datahistory?.approvalStatus == "Submitted for Approval") &&
                                                                    <div class='subForApproval' style={{ paddingLeft: (index % 3 === 0) && "0" }}>
                                                                        <div class="trackhistorydivcol3">
                                                                            <small class="trackhistorydivtexth">{datahistory?.approvalStatus}</small>
                                                                            <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                        </div>
                                                                        <div class="trackhistorydivcol4">
                                                                            <Link onClick={() => this.downloadDocument(datahistory?.documentPath)}>
                                                                                <img
                                                                                    src={download}
                                                                                    class="" id=""
                                                                                    alt="" loading="lazy"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {(datahistory?.approvalStatus == "Submitted for Approval") &&
                                                                    <div class="onlycolformobile">
                                                                        <div class="trackhistorydivcol3mobile">
                                                                            <small class="trackhistorydivtexth">{datahistory?.approvalStatus}</small>
                                                                            <small class="trackhistorydivtextb">{FormatTimeStamp(datahistory?.approvalDate)?.timedateToLocale}</small>
                                                                        </div>
                                                                        <div class="trackhistorydivcol4mobile">
                                                                            <Link onClick={() => this.downloadDocument(datahistory?.documentPath)}>
                                                                                <img
                                                                                    src={download}
                                                                                    class="ml-3 mb-1" id=""
                                                                                    alt="" loading="lazy"
                                                                                />
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        );
                                                    }))}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }))}
                            </div>
                            : <div class="noproxy">
                                <small id="noproxyavailable">{Message?.proxy?.proxyError}</small>
                            </div>
                        }
                    </div>
                </div>
                <div class="caanotifooter01ahztrack">
                    <Footer />
                </div>
                <div class="caanotifooter02ahztrack">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default TrackHistoryforProxy;